import member1 from '../../assets/member1.jpg';
import member2 from '../../assets/member2.jpg';
import member3 from '../../assets/member3.png';
import member4 from '../../assets/member1.jpg';
import member5 from '../../assets/member1.jpg';

export const teamMembers = [
  {
    imgSrc: member1,
    name: 'Suhyun Park',
    title: 'Project Owner',
    role: 'Lead responsibility for project management'
  },
  {
    imgSrc: member2,
    name: 'James Jo',
    title: 'Scrum Master',
    role: 'Manage the Agile process'
  },
  {
    imgSrc: member3,
    name: 'Hailey Kim',
    title: 'UX Designer / Developer',
    role: 'Responsible for the user interface design'
  },
  {
    imgSrc: member4,
    name: 'Amy Ahn',
    title: 'Designer / Developer',
    role: 'Design and development support'
  },
  {
    imgSrc: member5,
    name: 'May Kim',
    title: 'Main Developer',
    role: 'Lead development efforts'
  }
];
